import React, { useState, useEffect, useRef, use } from "react";
import { Box, CircularProgress, LinearProgress } from "@mui/material";
import priceCalculator from "@heartinz/gst_india_product_price_calculator";
import dayjs from "dayjs";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import CustomUnit from "../product/CustomUnit";
import { useNetwork } from "../../../context/NetworkContext";
import { useAuth } from "../../../context/AuthProvider";
import GetServerLiveTime from "../../../constants/GetServerLiveTime";
import { useShowAlert } from "../../../context/AlertContext";
import { usePermission } from "../../../context/PermissionContext";
import DateConverter from "@heartinz/date_and_time_processor";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import Messages from "../../../constants/Messages";
import uRLs from "../../../utils/baseUtils";
import { handleUnitselect } from "../../../utils/unitUtils";
import { AddIcon, BarcodeIcon, EditIcon, XIcon } from "../../../constants/Icons";

const AddNewProduct = ({
  onClose,
  onSubmit,
  isActive,
  noteSuggests,
  brandSuggest,
  setBrandSuggest,
  noteOpenStatus,
  setIsAnyInputFocused,
  initialData,
}) => {
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [isButtonLoading, setButtonLoading] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [unitSuggest, setUnitSuggest] = useState([]);

  const [imagePreview, setImagePreview] = useState(
    "/assets/images/avatars/default.jpg",
  );
  const [tags, setTags] = useState([]);
  const [tagInput, setTagInput] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [AddUnitopen, setAddUnitopen] = useState(false);
  const hasFetched = useRef(false);
  const [unitData, setUnitData] = useState();
  const [payloadData, setPayloadData] = useState();
  const [error, setErrors] = useState("");
  const itemRefs = useRef([]);
  const [isBrandFocused, setIsBrandFocused] = useState(false);
  const [filteredBrand, setFilteredBrand] = useState([]);
  const [brandIndex, setBrandIndex] = useState(-1);
  const [showSuggestions, setShowSuggestions] = useState(false);
  // const [isSelectedRadio, setSelectedRadio] = useState("SALEPRICE");
  const { checkNetwork } = useNetwork();
  const { isUser,settings } = useAuth();
  const [toggles, setToggles] = useState({ stock: false });
  const [loading, setLoading] = useState({ stock: false });
  const serverTime = GetServerLiveTime();
  const showAlert = useShowAlert();
  const productCodeRef = useRef(null);
  const productCodeGenerate = useRef(null);
  const productHsnsacRef = useRef(null);
  const productTitleRef = useRef(null);
  const searchTagRef = useRef(null);
  const brandRef = useRef(null);
  const primaryRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [brandData, setBrandData] = useState({
    title: "",
    _id: "",
  });
  const manufacturedateRefs = useRef(null);
  const productMdateRef = useRef(null);
  const productNoteRef = useRef(null);
  const productMrpRef = useRef(null);
  const productSalepriceRef = useRef(null);
  const productTaxpercentageRef = useRef(null);
  const productBasepriceRef = useRef(null);
  const addProductBtnRef = useRef(null);
  const popupMrpInputRef = useRef(null);
  const productLandingCostRef = useRef(null);
  const [showMrpPopup, setShowMrpPopup] = useState(false);
  const [popupMrpValue, setPopupMrpValue] = useState("");
  const [popupMrpStyle, setPopupMrpStyle] = useState({});
  const [noteSuggest, setNoteSuggest] = useState([]);
  const [showNotePopup, setShowNotePopup] = useState(false);
  const [filteredNoteSuggestions, setFilteredNoteSuggestions] = useState([]);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const suggestionNoteRef = useRef([]);
  const containerRef = useRef(null);
  const [isProductData, setProductData] = useState({
    code: "",
    hsnsac: "",
    title: "",
    note: "",
    mrp: 0,
    quantity: 0,
    saleprice: 0,
    taxpercentage: 0,
    discount: 0,
    baseprice: 0,
    taxamount: 0,
    landingcost: 0,
    isLock: "SALEPRICE",
    primaryUnit: "",
    secondaryUnit: "",
    conversionValue: 0,
  });
  // const [isApiData, setApiData] = useState({
  //   code: "",
  //   hsnsac: "",
  //   title: "",
  //   note: "",
  //   mrp: 0,
  //   quantity: 0,
  //   saleprice: 0,
  //   taxpercentage: 0,
  //   discount: 0,
  //   baseprice: 0,
  //   taxamount: 0,
  //   landingcost: 0,
  //   isLock: "SALEPRICE",
  //   primaryUnit:"",
  //   secondaryUnit:"",
  //   conversionValue:0,
  // });
  const {
    permission,
    hasPermission,
    viewOption,
    setGlobelPopupOpen,
    blockedPermissions,
  } = usePermission();

  const iso = serverTime.toISOString();
  const indiaTime = DateConverter.convertToTimeZone(iso, isUser?.timezone);

  const [manufacturedate, setMDate] = useState("");
  const [expiredate, setEDate] = useState("");
  const [expireMinDate, setExpireMinDate] = useState(iso);
  const [selectedUnit, setSelectedUnit] = useState();
  const [purchaseLock, setPurchaseLock] = useState("WITHTAX");

  const handleMDateChange = ([selectedDate]) => {
    const iso = selectedDate.toISOString();
    const indiaTime = DateConverter.convertToTimeZone(iso, isUser?.timezone);
    setMDate(indiaTime);
    setExpireMinDate(indiaTime);
  };

  const handleEDateChange = ([selectedDate]) => {
    const iso = selectedDate.toISOString();
    const indiaTime = DateConverter.convertToTimeZone(iso, isUser?.timezone);
    setEDate(indiaTime);
  };

  // const handleSelectBrand = (item) => {
  //   setProductData((prev) => ({
  //     ...prev,
  //     brandName: item.title,
  //   }));

  //   setFilteredBrand([]);
  //   setIsBrandFocused(false);
  // };
  const handleSelectBrand = (item) => {
    setBrandData((prev) => ({
      ...prev,
      title: item?.title,
      _id: item?._id,
    }));

    setShowSuggestions(false);
  };
  const handleBrandKeyDown = (e) => {
    const value = searchTerm?.trim();
    const hasAddOption =
      searchTerm?.trim() !== "" && filteredBrand?.length === 0;

    const totalItems = hasAddOption ? 1 : filteredBrand?.length;
    // if (totalItems === 0) return;
    if (filteredBrand?.length === 0) {
      if (e.key === "Enter" && value !== "") {
        e.preventDefault();
        handleBrandAdd(value);
        setShowSuggestions((prev) => !prev);
        productNoteRef.current?.focus();
      }
      return;
    }

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setBrandIndex((prev) => (prev < totalItems - 1 ? prev + 1 : 0));
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      setBrandIndex((prev) => (prev > 0 ? prev - 1 : totalItems - 1));
    }

    if (e.key === "Enter") {
      e.preventDefault();
      if (value === "" && brandIndex === -1) {
        setShowSuggestions((prev) => !prev);
        productNoteRef.current?.focus();
        return;
      }

      //  ADD NEW
      if (hasAddOption && brandIndex === 0) {
        handleBrandAdd(searchTerm);
        productNoteRef.current?.focus();
        return;
      }

      //  SELECT EXISTING
      if (brandIndex >= 0 && filteredBrand[brandIndex]) {
        handleSelectBrand(filteredBrand[brandIndex]);
        productNoteRef.current?.focus();
      }
    }
  };

  // const handleSuggestUnit = async () => {
  //   try {
  //     if (!checkNetwork()) return;
  //     const response = await AxiosInstance.get(`module/unit`);

  //     setUnitSuggest(response.data.results || []);
  //     // setShowtitlePopup(true);
  //   } catch (error) {
  //     handleError(error, showAlert);
  //     return false;
  //   }
  // };

  const handleUnit = (payload) => { 

    handleUnitselect(payload,setUnitData,setPayloadData,setUnitSuggest);
  };

  const handleCalculate = (updatedData) => {
    var { mrp, saleprice, baseprice, taxpercentage } = updatedData;
    let numericMrp = CurrencyConverter.toSubunit(mrp || 0, "INR");
    let numericSaleprice = CurrencyConverter.toSubunit(saleprice || 0, "INR");
    let numericBaseprice = CurrencyConverter.toSubunit(baseprice || 0, "INR");
    let numericTaxpercentage = parseInt(taxpercentage);
    let quanity = parseInt(1);
    let calculationResult;
    let lock = isProductData.isLock;
    try {
      calculationResult = priceCalculator.getAllPriceList(
        numericMrp,
        numericSaleprice,
        numericBaseprice,
        numericTaxpercentage,
        quanity,
        lock,
      );
      if (lock === "SALEPRICE") {
        if (numericMrp !== calculationResult.mrp) {
          setProductData((prevData) => ({
            ...prevData,
            mrp: CurrencyConverter.toCurrency(calculationResult.mrp, "INR"),
            discount: CurrencyConverter.toCurrency(
              calculationResult.discount,
              "INR",
            ),
            taxamount: CurrencyConverter.toCurrency(
              calculationResult.gstAmount,
              "INR",
            ),
            baseprice: CurrencyConverter.toCurrency(
              calculationResult.basePrice,
              "INR",
            ),
          }));
          // setApiData((prevData) => ({
          //   ...prevData,
          //   mrp: calculationResult.mrp,
          //   discount:calculationResult.discount,
          //   taxamount:calculationResult.gstAmount,
          //   baseprice: calculationResult.basePrice,
          //   saleprice: calculationResult.salePrice,
          // }));
        }
        setProductData((prevData) => ({
          ...prevData,
          discount: CurrencyConverter.toCurrency(
            calculationResult.discount,
            "INR",
          ),
          taxamount: CurrencyConverter.toCurrency(
            calculationResult.gstAmount,
            "INR",
          ),
          baseprice: CurrencyConverter.toCurrency(
            calculationResult.basePrice,
            "INR",
          ),
        }));
        // setApiData((prevData) => ({
        //   ...prevData,
        //   mrp: calculationResult.mrp,
        //   discount: calculationResult.discount,
        //   taxamount: calculationResult.gstAmount,
        //   baseprice: calculationResult.basePrice,
        //   saleprice: calculationResult.salePrice,
        // }));
      } else if (lock === "BASEPRICE") {
        if (numericMrp !== calculationResult.mrp) {
          setProductData((prevData) => ({
            ...prevData,
            mrp: CurrencyConverter.toCurrency(calculationResult.mrp, "INR"),
            discount: CurrencyConverter.toCurrency(
              calculationResult.discount,
              "INR",
            ),
            taxamount: CurrencyConverter.toCurrency(
              calculationResult.gstAmount,
              "INR",
            ),
            saleprice: CurrencyConverter.toCurrency(
              calculationResult.salePrice,
              "INR",
            ),
          }));
          // setApiData((prevData) => ({
          //   ...prevData,
          //   mrp: calculationResult.mrp,
          //   discount: calculationResult.discount,
          //   taxamount: calculationResult.gstAmount,
          //   saleprice: calculationResult.salePrice,
          //   baseprice: calculationResult.basePrice,
          // }));
        }
        setProductData((prevData) => ({
          ...prevData,
          discount: CurrencyConverter.toCurrency(
            calculationResult.discount,
            "INR",
          ),
          taxamount: CurrencyConverter.toCurrency(
            calculationResult.gstAmount,
            "INR",
          ),
          saleprice: CurrencyConverter.toCurrency(
            calculationResult.salePrice,
            "INR",
          ),
        }));
        // setApiData((prevData) => ({
        //   ...prevData,
        //   mrp: calculationResult.mrp,
        //   discount: calculationResult.discount,
        //   taxamount: calculationResult.gstAmount,
        //   saleprice: calculationResult.salePrice,
        //   baseprice: calculationResult.basePrice,
        // }));
      }
    } catch (error) {
      showAlert("warning", error.message || Messages.ERROR.INVALID_INPUT);
    }
  };

  // const handleCalculate = (data) => {
  //   try {
  //     // ✅ 1. Normalize input (convert once)
  //     const toSub = (val) =>
  //       Number(CurrencyConverter.toSubunit(val || 0, "INR")) || 0;

  //     const toCur = (val) => CurrencyConverter.toCurrency(val || 0, "INR");

  //     const numeric = {
  //       mrp: toSub(data.mrp),
  //       saleprice: toSub(data.saleprice),
  //       baseprice: toSub(data.baseprice),
  //       purchaseWithTax: toSub(data.purchaseWithTax),
  //       purchaseWithoutTax: toSub(data.purchaseWithoutTax),
  //       quantity: parseInt(data.quantity) || 1,
  //       tax: parseInt(data.taxpercentage) || 0,
  //     };

  //     // ✅ 2. Safety rules
  //     if (numeric.saleprice > numeric.mrp) {
  //       numeric.mrp = numeric.saleprice;
  //     }

  //     const lock = data.isLock;
  //     const purchaseLockType = data.totalPurchaseAmountLock || purchaseLock;

  //     // ✅ 3. Prepare payload
  //     const payload = {
  //       mrp: numeric.mrp,
  //       salePricePerUnit: numeric.saleprice,
  //       basePricePerUnit: numeric.baseprice,
  //       lock,
  //       taxPercent: numeric.tax,
  //       quantity: numeric.quantity,
  //       totalPurchaseAmountWithTax: numeric.purchaseWithTax,
  //       totalPurchaseAmountWithOutTax: numeric.purchaseWithoutTax,
  //       totalPurchaseAmountLock: purchaseLockType,
  //       unitConfig:
  //         unitData && Object.keys(unitData).length > 0 ? unitData : undefined,
  //     };

  //     console.log(payload, "calculation payload");

  //     // ✅ 4. Calculation (single call)
  //     const result = getPurchaseAmount(
  //       payload.mrp,
  //       payload.salePricePerUnit,
  //       payload.basePricePerUnit,
  //       payload.lock,
  //       payload.taxPercent,
  //       payload.quantity,
  //       payload.unitConfig,
  //       payload.totalPurchaseAmountWithTax,
  //       payload.totalPurchaseAmountWithOutTax,
  //       payload.totalPurchaseAmountLock,
  //     );

  //     const { saleAmountList, purchaseAmountList } = result;
  //     console.log(result, "calculation result");
  //     console.log("saleAmountList", saleAmountList);
  //     console.log("purchaseAmountList", purchaseAmountList);

  //     // ✅ 5. Compute purchaseamount based on lock
  //     const purchaseamount =
  //       purchaseLockType === "WITHTAX"
  //         ? purchaseAmountList.lineTotalPurchasePriceWithTax
  //         : purchaseAmountList.lineTotalPurchasePriceWithoutTax;

  //     // ✅ 6. Update state (respect locks)
  //     setProductData((prev) => ({
  //       ...prev,

  //       // SALE
  //       mrp: toCur(saleAmountList.mrp),

  //       saleprice:
  //         lock === "SALEPRICE"
  //           ? prev.saleprice
  //           : toCur(saleAmountList.salePrice),

  //       baseprice:
  //         lock === "BASEPRICE"
  //           ? prev.baseprice
  //           : toCur(saleAmountList.basePrice),

  //       taxamount: toCur(saleAmountList.taxAmount),
  //       discount: toCur(saleAmountList.discount),

  //       // PURCHASE (respect lock)
  //       purchaseWithTax:
  //         purchaseLockType === "WITHTAX"
  //           ? prev.purchaseWithTax
  //           : toCur(purchaseAmountList.lineTotalPurchasePriceWithTax),

  //       purchaseWithoutTax:
  //         purchaseLockType === "WITHOUTTAX"
  //           ? prev.purchaseWithoutTax
  //           : toCur(purchaseAmountList.lineTotalPurchasePriceWithoutTax),

  //       // purchaseamount:
  //       //   purchaseLockType === "WITHTAX"
  //       //     ? purchaseAmountList.lineTotalPurchasePriceWithTax
  //       //     : purchaseAmountList.lineTotalPurchasePriceWithoutTax,
  //     }));
  //   } catch (error) {
  //     console.error("CALC ERROR:", error);
  //     showAlert("warning", error.message || Messages.ERROR.INVALID_INPUT);
  //   }
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let inputValue = value;
    if (name === "code") {
      const regex = /^[^\s]*$/;
      if (!regex.test(value)) inputValue = "";
    }
    if (name === "hsnsac") {
      // allow empty
      if (value === "") {
        inputValue = "";
      } else {
        // exactly 6 digits
        const regex = /^\d{0,8}$/;
        if (!regex.test(value)) {
          return; //  block invalid typing
        }
        inputValue = value;
      }
    }
    if (
      name === "mrp" ||
      name === "saleprice" ||
      name === "baseprice" ||
      name === "landingcost"
    ) {
      const regex = /^\d+(\.\d{0,2})?$/;
      if (!regex.test(value)) inputValue = "";
    }

    if (name === "taxpercentage") {
      const allowedValues = [0, 5, 12, 18, 24];
      if (!allowedValues.includes(Number(value))) inputValue = 0;
    }
    if (["quantity"].includes(name)) {
      if (uRLs.UNIT === "true") {
        // allow decimal with max 3 digits
        if (!/^\d*\.?\d{0,3}$/.test(value)) {
          return;
        }
      } else {
        // allow only integer
        if (!/^\d*$/.test(value)) {
          return;
        }
      }
    }
    if (name === "searchTag") {
      if (!/^[a-zA-Z0-9 ]*$/.test(value)) {
        return;
      }
    }
    if (name === "note") {
      // Filter suggestions dynamically
      if (value.trim() === "") {
        setFilteredNoteSuggestions(noteSuggest);
        setShowNotePopup(false);
        noteOpenStatus(false);
      } else {
        const filtered = {};

        Object.entries(noteSuggest).forEach(([category, items]) => {
          const matched = items.filter((item) =>
            item.toLowerCase().includes(value.toLowerCase()),
          );
          if (matched.length > 0) {
            filtered[category] = matched;
          }
        });

        setFilteredNoteSuggestions(filtered);
        setShowNotePopup(Object.keys(filtered).length > 0);
        noteOpenStatus(Object.keys(filtered).length > 0);
      }

      setHighlightedIndex(-1);
    }

    if (name === "brandName") {
      const valueLower = value.toLowerCase();

      // always start from full list
      let baseList = brandSuggest || [];

      if (value.trim() === "") {
        setFilteredBrand(baseList); // reset to full list
      } else {
        const filtered = baseList?.filter((item) =>
          item?.title?.toLowerCase().includes(valueLower),
        );
        setFilteredBrand(filtered);
      }

      setBrandIndex(-1);
      setIsBrandFocused(true); //  ensure dropdown stays open while typing
    }

    if (name === "purchaseWithTax" || name === "purchaseWithoutTax") {
      // allow decimal up to 2 digits
      if (!/^\d*\.?\d{0,2}$/.test(value)) {
        return;
      }

      // ✅ set correct lock when typing
      if (name === "purchaseWithTax") {
        setPurchaseLock("WITHTAX");
      } else {
        setPurchaseLock("WITHOUTTAX");
      }
    }

    const updatedData = {
      ...isProductData,
      [name]: inputValue,
      totalPurchaseAmountLock:
        name === "purchaseWithTax"
          ? "WITHTAX"
          : name === "purchaseWithoutTax"
            ? "WITHOUTTAX"
            : isProductData.totalPurchaseAmountLock || purchaseLock,
    };
    setProductData(updatedData);
    handleCalculate(updatedData);

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: validateField(name, inputValue),
    }));
  };

  const validateField = (name, value) => {
    switch (name) {
      case "title":
        return value.trim() === "" ? Messages.ERROR.TITLE_EMPTY : "";
      case "mrp":
        return value === "" ? Messages.ERROR.MRP_EMPTY : "";
      case "saleprice":
        return value === "" ? Messages.ERROR.SALEPRICE_EMPTY : "";
      // Add other validations as needed
      default:
        return "";
    }
  };

  const handleRadioChange = (inputName) => {
    setProductData((prev) => ({
      ...prev,
      isLock: inputName,
    }));
  };

  const resetForm = () => {
    setProductData({
      code: "",
      hsnsac: "",
      title: "",
      note: "",
      quantity: 0,
      mrp: 0,
      saleprice: 0,
      taxpercentage: 0,
      discount: 0,
      baseprice: 0,
      taxamount: 0,
      landingcost: "",
      isLock: "SALEPRICE",
      manufacturedate: "",
      expiredate: "",
    });
    // setApiData({
    //   code: "",
    //   hsnsac: "",
    //   title: "",
    //   note: "",
    //   quantity: 0,
    //   mrp: 0,
    //   saleprice: 0,
    //   taxpercentage: 0,
    //   discount: 0,
    //   baseprice: 0,
    //   taxamount: 0,
    //   landingcost: "",
    //   isLock: "SALEPRICE",
    //   manufacturedate: "",
    //   expiredate: "",
    // });
    setTags([]);
    setBrandData({
      title: "",
      _id: "",
    });
    setUnitData();
    setPayloadData();
    setImagePreview("/assets/images/avatars/default.jpg");
    setImageFile(null);
    setErrors("");
    setShowNotePopup(false);
    productTitleRef.current?.focus();
  };

  const validateForm = () => {
    const errors = {};

    if (!isProductData.title) {
      errors.title = Messages.ERROR.TITLE_EMPTY;
    } else if (!isProductData.code) {
      errors.code = Messages.ERROR.CODE_EMPTY;
    } else if (isProductData.code && !/^[^\s]*$/.test(isProductData.code)) {
      errors.name = Messages.ERROR.INVALID_INPUT;
    } else if (
      isProductData.hsnsac &&
      !/^\d{4,8}$/.test(isProductData.hsnsac)
    ) {
      errors.hsnsac = Messages.ERROR.INVALID_PRODUCT_HSN_SAC;
    } else if (
      isProductData.mrp === undefined ||
      isProductData.mrp === null ||
      isProductData.mrp === ""
    ) {
      errors.mrp = Messages.ERROR.MRP_EMPTY;
    } else if (
      isProductData.mrp &&
      !/^\d*\.?\d{0,2}$/.test(isProductData.mrp)
    ) {
      errors.mrp = Messages.ERROR.INVALID_INPUT;
    } else if (
      isProductData.saleprice === undefined ||
      isProductData.saleprice === null ||
      isProductData.saleprice === ""
    ) {
      errors.saleprice = Messages.ERROR.SALEPRICE_EMPTY;
    } else if (
      isProductData.saleprice &&
      !/^\d*\.?\d{0,2}$/.test(isProductData.saleprice)
    ) {
      errors.saleprice = Messages.ERROR.INVALID_INPUT;
    } else if (
      isProductData.taxpercentage === undefined ||
      isProductData.taxpercentage === null ||
      isProductData.taxpercentage === ""
    ) {
      errors.taxpercentage = Messages.ERROR.TAX_EMPTY;
    } else if (
      isProductData.taxpercentage &&
      !/^[0-9]*$/.test(isProductData.taxpercentage)
    ) {
      errors.taxpercentage = Messages.ERROR.INVALID_INPUT;
    } else if (
      isProductData.discount === undefined ||
      isProductData.discount === null ||
      isProductData.discount === ""
    ) {
      errors.discount = Messages.ERROR.DISCOUNT_EMPTY;
    } else if (
      isProductData.discount &&
      !/^\d*\.?\d{0,2}$/.test(isProductData.discount)
    ) {
      errors.discount = Messages.ERROR.INVALID_INPUT;
    } else if (
      isProductData.baseprice === undefined ||
      isProductData.baseprice === null ||
      isProductData.baseprice === ""
    ) {
      errors.baseprice = Messages.ERROR.BASEPRICE_EMPTY;
    } else if (
      isProductData.baseprice &&
      !/^\d*\.?\d{0,2}$/.test(isProductData.baseprice)
    ) {
      errors.baseprice = Messages.ERROR.INVALID_INPUT;
    } else if (
      isProductData.taxamount === undefined ||
      isProductData.taxamount === null ||
      isProductData.taxamount === ""
    ) {
      errors.taxamount = Messages.ERROR.TAXAMOUNT_EMPTY;
    } else if (
      isProductData.taxamount &&
      !/^\d*\.?\d{0,2}$/.test(isProductData.taxamount)
    ) {
      errors.taxamount = Messages.ERROR.INVALID_INPUT;
    } else if (
      isProductData.quantity &&
      !(uRLs.UNIT === "true"
        ? /^\d*\.?\d{0,3}$/.test(isProductData.quantity)
        : /^\d+$/.test(isProductData.quantity))
    ) {
      errors.quantity = Messages.ERROR.INVALID_INPUT;
      productMdateRef.current?.focus();
    }

    setErrors(errors);
    if (Object.keys(errors).length > 0) {
      const firstErrorField = Object.keys(errors)[0];
      switch (firstErrorField) {
        case "title":
          productTitleRef.current?.focus();
          break;
        case "code":
          productCodeRef.current?.focus();
          break;
        case "hsnsac":
          productHsnsacRef.current?.focus();
          break;
        case "mrp":
          productMrpRef.current?.focus();
          break;
        case "saleprice":
          productSalepriceRef.current?.focus();
          break;
        case "taxpercentage":
          productTaxpercentageRef.current?.focus();
          break;
        case "baseprice":
          productBasepriceRef.current?.focus();
          break;
        default:
          break;
      }
    }
    return Object.keys(errors).length === 0;
  };

  const handleClose = async () => {
    resetForm();
  };

  const handleClear = () => {
    resetForm();
    onClose();
  };

  const handleGenerateBarcode = async () => {
    if (
      hasPermission("PRODUCT", "PRODUCT:createBarcode") ||
      permission === undefined
    ) {
      setButtonLoading(true);
      try {
        if (!checkNetwork()) return;
        const response = await AxiosInstance.get(`module/product`);
        const newBarcode = response.data.results.barcode;
        setProductData((prevData) => ({
          ...prevData,
          code: newBarcode,
        }));
      } catch (error) {
        handleError(error, showAlert);
        return false;
      } finally {
        setButtonLoading(false);
        productCodeRef.current?.focus();
      }
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const onAdd = async (e) => {
    e.preventDefault();

    if (hasPermission("PRODUCT", "PRODUCT:add") || permission === undefined) {
      if (!validateForm()) return;

      const tagString = tags.join(" ");
      const formData = new FormData();
      formData.append("code", isProductData.code);
      formData.append("hsnsac", isProductData.hsnsac);
      formData.append("title", isProductData.title);
      formData.append(
        "mrp",
        CurrencyConverter.toSubunit(isProductData.mrp, "INR"),
      );
      formData.append(
        "saleprice",
        CurrencyConverter.toSubunit(isProductData.saleprice, "INR"),
      );
      formData.append("taxpercentage", isProductData.taxpercentage);
      formData.append(
        "discount",
        CurrencyConverter.toSubunit(isProductData.discount, "INR"),
      );
      formData.append(
        "baseprice",
        CurrencyConverter.toSubunit(isProductData.baseprice, "INR"),
      );
      formData.append(
        "taxamount",
        CurrencyConverter.toSubunit(isProductData.taxamount, "INR"),
      );
      formData.append("isLock", isProductData?.isLock);
      formData.append(
        "landingcost",
        CurrencyConverter.toSubunit(isProductData.landingcost || 0, "INR"),
      );
      if (tagString) {
        formData.append("searchTag", tagString);
      }
      if (brandData?.title) {
        formData.append("brandId", brandData?.title);
      }
      formData.append("note", isProductData?.note);
      // if (payloadData) {
      //   formData.append("unitConfig", JSON.stringify(payloadData));
      // }
      if (payloadData) {
        formData.append("primaryUnitCode", payloadData.primaryUnitCode);
        formData.append("secondaryUnitCode", payloadData.secondaryUnitCode);
        formData.append("conversion", payloadData.conversion);
      }
      // ✅ Quantity (send as number)
      if (isProductData?.quantity) {
        formData.append("openingStock", Number(isProductData.quantity));
      }

      // ✅ Purchase Amount (convert to paisa)
      if (isProductData.purchaseamount) {
        formData.append(
          "purchaseamount",
          CurrencyConverter.toSubunit(
            Number(isProductData.purchaseamount || 0),
            "INR",
          ),
        );
      }

      // ✅ Send tax type (IMPORTANT)
      formData.append("purchaseTaxType", purchaseLock);

      //  Append file only if it exists
      if (imageFile instanceof File) {
        formData.append("primaryImage", imageFile);
      } else {
        console.log("No image selected or wrong data type:", imageFile);
      }
      const allNotes = Object.values(noteSuggest).flat();

      // Clone existing suggestions safely
      let updatedSuggestions = { ...noteSuggest };

      // If the note does not exist anywhere, add it under General
      if (!allNotes.includes(isProductData.note)) {
        // If General category doesn't exist, create it
        if (!updatedSuggestions["General"]) {
          updatedSuggestions["General"] = [];
        }

        // Add the new note to General
        updatedSuggestions["General"] = [
          ...updatedSuggestions["General"],
          isProductData.note,
        ];
      }

      // Update state so UI refreshes immediately
      setNoteSuggest(updatedSuggestions);
      setFilteredNoteSuggestions(updatedSuggestions);
      // const tagString = tags.join(" ").trim();

      const payload = {
        ...isProductData,

        // ✅ money fields in paise
        mrp: Number(CurrencyConverter.toSubunit(isProductData.mrp || 0, "INR")),
        saleprice: Number(
          CurrencyConverter.toSubunit(isProductData.saleprice || 0, "INR"),
        ),
        baseprice: Number(
          CurrencyConverter.toSubunit(isProductData.baseprice || 0, "INR"),
        ),
        discount: Number(
          CurrencyConverter.toSubunit(isProductData.discount || 0, "INR"),
        ),
        taxamount: Number(
          CurrencyConverter.toSubunit(isProductData.taxamount || 0, "INR"),
        ),

        taxpercentage: Number(isProductData.taxpercentage || 0),

        unitConfig: payloadData,

        // ✅ conditional fields
        ...(tagString && { searchTag: tagString }),

        ...(brandData?._id && { brandId: brandData?.title }),

        ...(isProductData?.note?.trim() && { note: isProductData.note.trim() }),
      };
      try {
        await onSubmit(payload);
        resetForm();
        onClose();
      } catch (error) {
        console.error("Upload Error:", error);
      }
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };
  const handleBrandAdd = async (brandName) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.post(`module/product/brand`, {
        brandName: brandName,
      });
      const result = response?.data?.results;

      const newBrand = {
        _id: result?._id,
        title: result?.brandName,
      };

      setBrandSuggest((prev) => {
        // avoid duplicate
        const exists = prev.some((item) => item?.title === newBrand?.title);
        if (exists) return prev;

        return [newBrand, ...prev]; //  correct way
      });

      setBrandData((prev) => ({
        ...prev,
        title: newBrand.title,
        _id: newBrand._id,
      }));

      setShowSuggestions(false);
      setSearchTerm("");
      return newBrand?.title;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };
  const addTag = (value) => {
    const clean = value.trim().toLowerCase(); // 👈 convert to small letters

    if (!clean) return;

    if (!tags.includes(clean)) {
      setTags((prev) => [...prev, clean]);
    }

    setTagInput("");
  };

  const handleTagKeyDown = (e) => {
    const value = tagInput;

    //  ENTER → add tag
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      if (value) {
        addTag(value);
      } else if (
        toggles["stock"] &&
        viewOption("stockSettings", "isManufactureAndExpiryDates")
      ) {
        manufacturedateRefs.current?.focus(); // move to next field
      } else if (toggles["stock"]) {
        productMdateRef.current?.focus();
      } else {
        onAdd(e);
      }
      return;
    }

    //  BACKSPACE → remove last tag if input empty
    if (e.key === "Backspace" && !value) {
      setTags((prev) => prev.slice(0, -1));
      return;
    }

    //  INVALID KEY → create tag
    const isValidChar = /^[a-zA-Z0-9 .]$/.test(e.key);

    if (!isValidChar && e.key.length === 1) {
      e.preventDefault();
      addTag(value);
    }
  };

  const removeTag = (index) => {
    setTags(tags.filter((_, i) => i !== index));
  };

  const handleEnterKey = (e, fieldName, nextRef = null, isLast = false) => {
    const flatSuggestions = [
      ...(filteredNoteSuggestions["General"]
        ? filteredNoteSuggestions["General"]
        : []),
      ...Object.entries(filteredNoteSuggestions)
        .filter(([category]) => category !== "General")
        .flatMap(([_, items]) => items),
    ];

    if (showNotePopup && flatSuggestions.length > 0) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setHighlightedIndex((prev) =>
          prev < flatSuggestions.length - 1 ? prev + 1 : 0,
        );
        return;
      }

      if (e.key === "ArrowUp") {
        e.preventDefault();
        setHighlightedIndex((prev) =>
          prev > 0 ? prev - 1 : flatSuggestions.length - 1,
        );
        return;
      }

      if (e.key === "Enter") {
        e.preventDefault();
        if (highlightedIndex >= 0) {
          const selectedItem = flatSuggestions[highlightedIndex];
          setProductData((prev) => ({
            ...prev,
            note: selectedItem,
          }));
          setShowNotePopup(false);
          noteOpenStatus(false);
          setHighlightedIndex(-1);

          setTimeout(() => {
            // nextRef?.current?.focus();
          }, 100);
          return;
        }
      }
    }
    if (e.key === "Enter") {
      e.preventDefault();

      const code = String(isProductData["code"] || "").trim();
      if (fieldName === "code") {
        if (!code) {
          handleGenerateBarcode();
          setTimeout(() => {
            nextRef?.current?.focus();
          }, 100);
        } else {
          productHsnsacRef?.current?.focus();
        }
        return;
      }

      if (fieldName === "generate") {
        setTimeout(() => {
          nextRef?.current?.focus();
        }, 100);
        return;
      }

      if (fieldName === "title") {
        if (!isProductData.title?.trim()) {
          setErrors((prev) => ({
            ...prev,
            title: Messages.ERROR.TITLE_EMPTY,
          }));
          productTitleRef.current?.focus();
          return;
        } else {
          setErrors((prev) => {
            const { title, ...rest } = prev;
            return rest;
          });
        }
        setTimeout(() => {
          nextRef?.current?.focus();
        }, 100);
        return;
      }

      if (nextRef === productMrpRef) {
        const rect = productMrpRef.current.getBoundingClientRect();
        setPopupMrpStyle({
          position: "absolute",
          top: `${rect.top + window.scrollY}px`,
          left: `${rect.left + window.scrollX}px`,
          width: `${rect.width}px`,
          zIndex: 10000,
        });
        setPopupMrpValue(isProductData.mrp);
        setShowMrpPopup(true);
      }

      // const trimmedData = String(isProductData[fieldName] || "").trim();
      // const requiredFields = ["title"];

      // if (requiredFields.includes(fieldName) && !trimmedData) {
      //   setErrors((prev) => ({
      //     ...prev,
      //     [fieldName]:
      //       Messages.ERROR[`${fieldName.toUpperCase()}_EMPTY`] || "Required",
      //   }));
      //   return;
      // }

      if (isLast) {
        onAdd(e);
      }
      const nextInput =
        nextRef?.current?.input ||
        nextRef?.current?.flatpickr?.input ||
        nextRef?.current?.querySelector?.("input") ||
        nextRef?.current;

      if (nextInput && typeof nextInput.focus === "function") {
        nextInput.focus();
      } else {
        console.warn("Cannot focus nextRef:", nextRef);
      }
    }
  };

  // useEffect(() => {
  //   productCodeRef.current?.focus();
  // }, []);

  useEffect(() => {
    if (highlightedIndex >= 0 && suggestionNoteRef.current[highlightedIndex]) {
      suggestionNoteRef.current[highlightedIndex].scrollIntoView({
        block: "nearest",
        behavior: "smooth",
      });
    }
  }, [highlightedIndex]);

  const flatSuggestions = [
    ...(filteredNoteSuggestions["General"]
      ? filteredNoteSuggestions["General"]
      : []),
    ...Object.entries(filteredNoteSuggestions)
      .filter(([category]) => category !== "General")
      .flatMap(([_, items]) => items),
  ];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowNotePopup(false);
        noteOpenStatus(false);
        setHighlightedIndex(-1);
      }
      setIsAnyInputFocused(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (!isActive) return;
    const timer = setTimeout(() => {
      productTitleRef.current?.focus();
    }, 0);
    return () => clearTimeout(timer);
  }, [isActive]);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    // handleSuggestNote();
    // handleSuggestUnit();
    setUnitSuggest({
      defaultUnits: settings?.defaultUnits || [],
      storeUnits: settings?.storeUnits || []
    })
  }, []);
  useEffect(() => {
    if (
      noteSuggests &&
      typeof noteSuggests === "object" &&
      Object.keys(noteSuggests).length > 0
    ) {
      setNoteSuggest(noteSuggests);
    }
  }, [noteSuggests]);
  useEffect(() => {
    setSelectedUnit(unitData?.primaryUnitCode);
  }, [unitData]);
  useEffect(() => {
    if (showSuggestions) {
      setFilteredSuggestions(brandSuggest);
    }
  }, [brandSuggest, showSuggestions]);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (primaryRef.current && !primaryRef.current.contains(e.target)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  useEffect(() => {
    if (brandIndex >= 0) {
      itemRefs.current[brandIndex]?.scrollIntoView({
        block: "nearest",
        behavior: "smooth",
      });
    }
  }, [brandIndex]);

  useEffect(() => {
    if ((initialData && initialData?.title) || initialData?.code) {
      setProductData((prev) => ({
        ...prev,
        code: initialData?.code || prev?.code,
        title: initialData?.title || prev?.title,
      }));
    }
  }, [initialData]);

  useEffect(() => {
    if (initialData?.code) {
      productTitleRef.current?.focus();
    } else if (initialData?.title) {
      productCodeRef.current?.focus();
    }
  }, [initialData]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEsc);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  return (
    <>
      <div className="modal-backdrop show"></div>
      <div className="modal show" style={{ display: "block" }}>
        <div className="modal-dialog  modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            {/* HEADER */}
            <div className="modal-header">
              <h6 className="modal-title">Add New Product</h6>
              <button
                type="button"
                className="btn-close"
                onClick={handleClear}
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            {/* BODY */}
            <div className="modal-body bg-light">
              <div>
                <div className="card mt-3">
                  <div className="card-body">
                    <div className="row g-3">
                      <div className={uRLs.UNIT == "true" ? "col-8" : "col-12"}>
                        <label htmlFor="title" className="form-label">
                          Title <span className="text-danger">*</span>
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          name="title"
                          autoComplete="off"
                          ref={productTitleRef}
                          value={isProductData?.title}
                          onChange={handleChange}
                          onFocus={() => setIsAnyInputFocused(true)}
                          onKeyDown={(e) =>
                            handleEnterKey(e, "title", productCodeRef)
                          }
                        />
                        {error.title && (
                          <div className="invalid-feedback">{error.title}</div>
                        )}
                      </div>
                      {uRLs.UNIT === "true" && (
                        <div className="col-4">
                          <label htmlFor="unit" className="form-label">
                            Unit
                          </label>
                          <div className="d-flex align-items-center">
                            <button
                              type="button"
                              className="btn btn-unit fs-10 w-100 d-flex align-items-center justify-content-between"
                              onClick={() => {
                                setAddUnitopen(true);
                                setGlobelPopupOpen(true);
                              }}
                            >
                              {unitData?.primaryUnitName ? (
                                <>
                                  <span>{unitData?.primaryUnitName}</span>{" "}
                                  <EditIcon iClass={"me-1"}/>
                                </>
                              ) : (
                                <>
                                  <span>Unit</span>{" "}
                                  <AddIcon iClass={"mt-1"}/>
                                </>
                              )}
                            </button>
                          </div>
                          {unitData && (
                            <span>
                              1 {unitData?.primaryUnitCode} ={" "}
                              {unitData?.secondaryUnitCode
                                ? `${unitData?.conversion} ${unitData?.secondaryUnitCode}`
                                : "1 Unit"}
                            </span>
                          )}
                        </div>
                      )}

                      <div className="col-lg-8 col-xl-8 col-md-6 col-sm-6">
                        <label htmlFor="phone" className="form-label">
                          Barcode / SKU / Code{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="d-flex align-items-center justify-content-between">
                          <input
                            type="text"
                            className="form-control me-2"
                            name="code"
                            autoComplete="off"
                            ref={productCodeRef}
                            value={isProductData.code}
                            onInput={handleChange}
                            onFocus={() => setIsAnyInputFocused(true)}
                            onKeyDown={(e) =>
                              handleEnterKey(e, "code", productCodeGenerate)
                            }
                          />
                          <div className="d-inline-block">
                            {isButtonLoading ? (
                              <button className="btn btn-primary pb-0" disabled>
                                <CircularProgress
                                  size={22}
                                  className="text-white"
                                />
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-primary fs-10 d-flex align-items-center"
                                onClick={handleGenerateBarcode}
                                ref={productCodeGenerate}
                                onFocus={() => setIsAnyInputFocused(true)}
                                onKeyDown={(e) =>
                                  handleEnterKey(
                                    e,
                                    "generate",
                                    productHsnsacRef,
                                  )
                                }
                              >
                                <BarcodeIcon iClass={"me-1"}/> Generate
                              </button>
                            )}
                          </div>
                        </div>
                        {error.code && (
                          <div className="invalid-feedback">{error.code}</div>
                        )}
                      </div>

                      <div className="col-lg-4 col-xl-4 col-md-6 col-sm-6">
                        <label htmlFor="hsnsac" className="form-label">
                          {" "}
                          HSN/SAC <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="hsnsac"
                          autoComplete="off"
                          ref={productHsnsacRef}
                          value={isProductData.hsnsac}
                          onFocus={() => setIsAnyInputFocused(true)}
                          onChange={handleChange}
                          onKeyDown={(e) =>
                            handleEnterKey(e, "hsnsac", productMrpRef)
                          }
                        />
                        {error.hsnsac && (
                          <div className="invalid-feedback">{error.hsnsac}</div>
                        )}
                      </div>

                      <div className="col-lg-4 col-xl-4 col-md-4 col-sm-4">
                        <label htmlFor="mrp" className="form-label">
                          MRP
                        </label>

                        <div className="position-relative">
                          <input
                            type="text"
                            className="form-control"
                            name="mrp"
                            autoComplete="off"
                            ref={productMrpRef}
                            value={isProductData.mrp}
                            onFocus={(e) => {
                              e.target.select();
                              setIsAnyInputFocused(true);
                            }}
                            onChange={handleChange}
                            onKeyDown={(e) =>
                              handleEnterKey(e, "mrp", productSalepriceRef)
                            }
                            onClick={() => {
                              setPopupMrpValue(isProductData.mrp);
                              setShowMrpPopup(true);
                            }}
                          />
                          {showMrpPopup && (
                            <input
                              type="text"
                              ref={popupMrpInputRef}
                              value={popupMrpValue}
                              autoFocus
                              onFocus={(e) => e.target.select()}
                              onBlur={() => setShowMrpPopup(false)}
                              onChange={(e) => {
                                const val = e.target.value;
                                const regex = /^\d+(\.\d{0,2})?$/;

                                if (val === "" || regex.test(val)) {
                                  setPopupMrpValue(val);
                                  setProductData((prev) => ({
                                    ...prev,
                                    mrp: val,
                                  }));
                                  handleCalculate({
                                    ...isProductData,
                                    mrp: val,
                                  });
                                }
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  setShowMrpPopup(false);
                                  productSalepriceRef.current?.focus();
                                }
                              }}
                              className="form-control position-absolute"
                              style={{
                                inset: 0, //  THIS is the key
                                zIndex: 10,
                              }}
                            />
                          )}
                        </div>
                        {error.mrp && (
                          <div className="invalid-feedback">{error.mrp}</div>
                        )}
                      </div>

                      <div className="col-lg-4 col-xl-4 col-md-4 col-sm-4">
                        <label htmlFor="saleprice" className="form-label">
                          Sale Price <span className="text-danger">*</span>
                        </label>

                        <div className="input-container position-relative">
                          <input
                            type="text"
                            name="saleprice"
                            autoComplete="off"
                            ref={productSalepriceRef}
                            value={isProductData.saleprice}
                            className="form-control"
                            onFocus={(e) => {
                              e.target.select();
                              setIsAnyInputFocused(true);
                            }}
                            onClick={() => handleRadioChange("SALEPRICE")}
                            style={{ paddingLeft: "30px" }}
                            onChange={handleChange}
                            onKeyDown={(e) =>
                              handleEnterKey(
                                e,
                                "saleprice",
                                productTaxpercentageRef,
                              )
                            }
                          />
                          <input
                            type="radio"
                            name="selectInput"
                            checked={isProductData?.isLock === "SALEPRICE"}
                            onChange={() => handleRadioChange("SALEPRICE")}
                            className="position-absolute"
                            style={{
                              top: "50%",
                              left: "10px",
                              transform: "translateY(-50%)",
                              zIndex: 2,
                            }}
                          />
                        </div>
                        {error.saleprice && (
                          <div className="invalid-feedback">
                            {error.saleprice}
                          </div>
                        )}
                      </div>

                      <div className="col-lg-4 col-xl-4 col-md-4 col-sm-4">
                        <label htmlFor="FisrtName" className="form-label">
                          Tax(%) <span className="text-danger">*</span>
                        </label>
                        <select
                          name="taxpercentage"
                          className="form-select"
                          ref={productTaxpercentageRef}
                          value={isProductData.taxpercentage}
                          onChange={handleChange}
                          onFocus={() => setIsAnyInputFocused(true)}
                          onKeyDown={(e) =>
                            handleEnterKey(
                              e,
                              "taxpercentage",
                              productBasepriceRef,
                            )
                          }
                        >
                          <option value="0">0</option>
                          <option value="5">5</option>
                          <option value="12">12</option>
                          <option value="18">18</option>
                          <option value="24">24</option>
                        </select>
                      </div>

                      <div className="col-lg-4 col-xl-4 col-md-4 col-sm-4">
                        <label htmlFor="discount" className="form-label">
                          Discount
                        </label>
                        <input
                          readOnly=""
                          type="text"
                          name="discount"
                          autoComplete="off"
                          value={isProductData.discount}
                          className="form-control"
                          disabled
                        />
                      </div>

                      <div className="col-lg-4 col-xl-4 col-md-4 col-sm-4">
                        <label htmlFor="baseprice" className="form-label">
                          Base Price
                        </label>

                        <div className="input-container position-relative">
                          <input
                            type="text"
                            name="baseprice"
                            autoComplete="off"
                            ref={productBasepriceRef}
                            onClick={() => handleRadioChange("BASEPRICE")}
                            onChange={handleChange}
                            value={isProductData.baseprice}
                            onFocus={(e) => {
                              e.target.select();
                              setIsAnyInputFocused(true);
                            }}
                            className="form-control"
                            style={{ paddingLeft: "30px" }}
                            onKeyDown={(e) => {
                              handleEnterKey(e, "baseprice", brandRef);
                              if (e.key === "Enter") {
                                setShowSuggestions((prev) => !prev);
                                setFilteredBrand(brandSuggest);
                              }
                            }}
                          />
                          <input
                            type="radio"
                            name="selectInput"
                            className="position-absolute"
                            checked={isProductData?.isLock === "BASEPRICE"}
                            onChange={() => handleRadioChange("BASEPRICE")}
                            style={{
                              top: "50%",
                              left: "10px",
                              transform: "translateY(-50%)",
                              zIndex: 2,
                            }}
                          />
                        </div>
                        {error.baseprice && (
                          <div className="invalid-feedback">
                            {error.baseprice}
                          </div>
                        )}
                      </div>

                      <div className="col-lg-4 col-xl-4 col-md-4 col-sm-4">
                        <label htmlFor="taxamount" className="form-label">
                          Tax Amount
                        </label>
                        <input
                          readOnly=""
                          type="text"
                          name="taxamount"
                          autoComplete="off"
                          className="form-control"
                          value={isProductData.taxamount}
                          disabled
                        />
                      </div>

                      {/* <div className="col-4">
                        <div className="d-flex align-items-center">
                          <label htmlFor="landingcost" className="form-label">
                            Landing Cost <small>(Per Unit) (Optional)</small>
                          </label>
                          <span className="tooltip-container">
                            <span className="tooltip-icon">?</span>
                            <span className="tooltip-text">
                              Total cost to bring the product to your inventory,
                              including purchase price and taxes.
                            </span>
                          </span>
                        </div>
                        <div className="input-container position-relative">
                          <input
                            type="text"
                            name="landingcost"
                            autoComplete="off"
                            ref={productLandingCostRef}
                            value={isProductData.landingcost}
                            className="form-control"
                            onFocus={(e) => {
                              e.target.select();
                              setIsAnyInputFocused(true);
                            }}
                            onChange={handleChange}
                            onKeyDown={(e) => {
                              handleEnterKey(e, "landingcost", brandRef);
                              if (e.key === "Enter") {
                                setShowSuggestions((prev) => !prev);
                                setFilteredBrand(brandSuggest);
                              }
                            }}
                          />
                        </div>
                      </div> */}

                      <div className="col-5">
                        <label className="form-label">Brand</label>

                        <div className="position-relative" ref={primaryRef}>
                          {/* Trigger */}
                          <div
                            className="form-control d-flex justify-content-between align-items-center"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setShowSuggestions((prev) => !prev);
                              setSearchTerm("");
                              setFilteredBrand(brandSuggest); //  show all
                              setBrandIndex(-1);
                            }}
                          >
                            <span
                              className={brandData?.title ? "" : "text-muted"}
                            >
                              {brandData?.title || "Select brand"}
                            </span>
                            <span className="d-flex align-items-center">
                              {brandData?.title && (
                                // <i className="bx bx-x me-2" onClick={()=>setBrandData("")}></i>
                                <CancelRoundedIcon
                                  sx={{ fontSize: 15 }}
                                  onClick={() => setBrandData("")}
                                />
                              )}
                              <i
                                className={`bx bx-chevron-${showSuggestions ? "up" : "down"}`}
                              />
                            </span>
                          </div>

                          {/* Dropdown */}
                          {showSuggestions && (
                            <div
                              className="dropdown-menu show w-100 p-2 mt-1 shadow-sm"
                              style={{
                                borderBottomLeftRadius: "0px",
                                borderBottomRightRadius: "0px",
                              }}
                            >
                              {/* Search */}
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search or add new..."
                                ref={brandRef}
                                value={searchTerm}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setSearchTerm(value);

                                  if (value.trim() === "") {
                                    setFilteredBrand(brandSuggest);
                                  } else {
                                    const filtered = brandSuggest.filter(
                                      (item) =>
                                        item.title
                                          .toLowerCase()
                                          .includes(value.toLowerCase()),
                                    );
                                    setFilteredBrand(filtered);
                                  }

                                  setBrandIndex(-1);
                                }}
                                onFocus={() => setIsAnyInputFocused(true)}
                                onKeyDown={handleBrandKeyDown}
                                autoFocus
                              />

                              <ul
                                className="suggestions-list"
                                style={{
                                  maxHeight: "150px",
                                  overflowY: "auto",
                                  border: "0px",
                                  borderTopLeftRadius: "0px",
                                  borderTopRightRadius: "0px",
                                }}
                              >
                                {/*  Add new */}
                                {/* {searchTerm.trim() !== "" && ( */}
                                {filteredBrand?.length === 0 &&
                                  searchTerm?.trim() !== "" && (
                                    <li
                                      className={`suggestion-item text-primary ${
                                        brandIndex === 0
                                          ? "highlighted rounded"
                                          : ""
                                      }`}
                                      onMouseDown={() =>
                                        handleBrandAdd(searchTerm)
                                      }
                                    >
                                      <span className="p-2 rounded-5 bg-label-kids">
                                        <AddIcon iClass={"me-1"}/>{" "}
                                        "{searchTerm}"
                                      </span>
                                    </li>
                                  )}

                                {/* List */}
                                {filteredBrand?.map((item, index) => (
                                  <li
                                    key={item?._id}
                                    className={`suggestion-item mx-2 ${
                                      index === brandIndex
                                        ? "highlighted rounded"
                                        : ""
                                    }`}
                                    ref={(el) => (itemRefs.current[index] = el)}
                                    onMouseDown={() => handleSelectBrand(item)}
                                  >
                                    {item?.title}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-7">
                        <label htmlFor="title" className="form-label">
                          Note
                        </label>
                        <div className="position-relative" ref={containerRef}>
                          <input
                            type="text"
                            className="form-control"
                            name="note"
                            autoComplete="off"
                            ref={productNoteRef}
                            value={isProductData.note}
                            onChange={handleChange}
                            onKeyDown={(e) => {
                              if (
                                viewOption("productSettings", "isProductTag")
                              ) {
                                handleEnterKey(e, "note", searchTagRef);
                              } else if (
                                toggles["stock"] &&
                                viewOption(
                                  "stockSettings",
                                  "isManufactureAndExpiryDates",
                                )
                              ) {
                                handleEnterKey(e, "note", manufacturedateRefs);
                              } else if (toggles["stock"]) {
                                handleEnterKey(e, "note", productMdateRef);
                              } else {
                                handleEnterKey(e, "note", null, true);
                              }
                            }}
                            onFocus={() => {
                              setFilteredNoteSuggestions(noteSuggest);
                              setShowNotePopup(true);
                              noteOpenStatus(true);
                              setHighlightedIndex(-1);
                              setIsAnyInputFocused(true);
                            }}
                            onBlur={() => {
                              setTimeout(() => {
                                setShowNotePopup(false);
                                noteOpenStatus(false);
                              }, 150);
                            }}
                          />

                          {showNotePopup &&
                            Object.values(filteredNoteSuggestions).flat()
                              .length > 0 && (
                              <ul className="suggestions-list-top">
                                {[
                                  // Put "General" first if it exists
                                  ...(filteredNoteSuggestions["General"]
                                    ? [
                                        [
                                          "General",
                                          filteredNoteSuggestions["General"],
                                        ],
                                      ]
                                    : []),

                                  // Then add all other categories
                                  ...Object.entries(
                                    filteredNoteSuggestions,
                                  ).filter(
                                    ([category]) => category !== "General",
                                  ),
                                ].map(([category, items], catIndex) => (
                                  <li key={catIndex}>
                                    <div className="suggestion-item highlighted-title">
                                      {category}
                                    </div>
                                    <ul className="suggestions-list-inside">
                                      {items.map((item, idx) => {
                                        const flatIndex =
                                          flatSuggestions.indexOf(item);
                                        return (
                                          <li
                                            key={`${catIndex}-${idx}`}
                                            ref={(el) =>
                                              (suggestionNoteRef.current[
                                                flatIndex
                                              ] = el)
                                            }
                                            className={`suggestion-item ${
                                              highlightedIndex === flatIndex
                                                ? "highlighted"
                                                : ""
                                            }`}
                                            onMouseDown={() => {
                                              setProductData((prev) => ({
                                                ...prev,
                                                note: item,
                                              }));
                                              setShowNotePopup(false);
                                              noteOpenStatus(false);
                                              setHighlightedIndex(-1);
                                            }}
                                            onFocus={() =>
                                              setIsAnyInputFocused(true)
                                            }
                                          >
                                            {item}
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  </li>
                                ))}
                              </ul>
                            )}
                        </div>
                      </div>
                      {viewOption("productSettings", "isProductTag") && (
                        <div className="col-12">
                          <label className="form-label">Search Tag</label>

                          <div className="tag-input-container">
                            {tags?.map((tag, index) => (
                              <span className="tag-chip" key={index}>
                                {tag}
                                <span
                                  className="tag-close"
                                  onClick={() => removeTag(index)}
                                >
                                  <CancelRoundedIcon sx={{ fontSize: 15 }} />
                                </span>
                              </span>
                            ))}

                            <input
                              type="text"
                              className="tag-input"
                              value={tagInput}
                              ref={searchTagRef}
                              onChange={(e) => setTagInput(e.target.value)}
                              onKeyDown={handleTagKeyDown}
                              onBlur={() => {
                                const value = tagInput.trim();
                                if (value) {
                                  addTag(value);
                                }
                              }}
                              placeholder="Type and press Enter"
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    {/* <div className="card mt-5">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-3">
                          <label htmlFor="quantity" className="form-label">
                            Quantity <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="quantity"
                            autoComplete="off"
                            ref={productMdateRef}
                            value={isProductData.quantity}
                            onFocus={(e) => e.target.select()}
                            onChange={handleChange}
                            onKeyDown={(e) => {
                              handleEnterKey(e, "quantity", null, true);
                            }}
                          />
                          {error.quantity && (
                            <div className="invalid-feedback">
                              {error.quantity}
                            </div>
                          )}
                        </div>
                        <div className="col-lg-8">
                          <label className="form-label">
                            Purchase Amount{" "}
                            <span className="text-danger">*</span>
                          </label>

                          <div className="row g-2">
                         
                            <div className="col-md-6">
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={isProductData.purchaseWithTax}
                                  onFocus={(e) => e.target.select()}
                                  onClick={() => setPurchaseLock("WITHTAX")}
                                  name="purchaseWithTax"
                                  onChange={handleChange}
                                  style={{ paddingLeft: "30px" }}
                                />
                                <input
                                  type="radio"
                                  checked={purchaseLock === "WITHTAX"}
                                  onChange={() => setPurchaseLock("WITHTAX")}
                                  className="position-absolute"
                                  style={{
                                    top: "50%",
                                    left: "10px",
                                    transform: "translateY(-50%)",
                                  }}
                                />
                              </div>
                              <small>With Tax</small>
                            </div>

                          
                            <div className="col-md-6">
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={isProductData.purchaseWithoutTax}
                                  onFocus={(e) => e.target.select()}
                                  onClick={() => setPurchaseLock("WITHOUTTAX")}
                                  name="purchaseWithoutTax"
                                  onChange={handleChange}
                                  style={{ paddingLeft: "30px" }}
                                />
                                <input
                                  type="radio"
                                  checked={purchaseLock === "WITHOUTTAX"}
                                  onChange={() => setPurchaseLock("WITHOUTTAX")}
                                  className="position-absolute"
                                  style={{
                                    top: "50%",
                                    left: "10px",
                                    transform: "translateY(-50%)",
                                  }}
                                />
                              </div>
                              <small>Without Tax</small>
                            </div>
                          </div>

                          {error.purchaseamount && (
                            <div className="invalid-feedback d-block">
                              {error.purchaseamount}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div> */}
                  </div>
                </div>
              </div>
            </div>

            {/* FOOTER */}
            <div className="modal-footer d-block">
              <button
                type="button"
                className="btn btn-outline-secondary text-left"
                onClick={handleClose}
              >
                <XIcon/> Cancel
              </button>
              {isBtnLoading ? (
                <button className="btn btn-primary pb-0 text-right" disabled>
                  <CircularProgress size={22} className="text-white" />
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-primary text-right"
                  onClick={onAdd}
                  ref={addProductBtnRef}
                >
                  <AddIcon/> Done
                </button>
              )}
            </div>

            {AddUnitopen && (
              <CustomUnit
                onclose={() => {
                  setAddUnitopen(false);
                  setGlobelPopupOpen(false);
                }}
                unitSuggest={unitSuggest}
                setUnitSuggest={setUnitSuggest}
                onAdd={handleUnit}
                selectedData={unitData}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AddNewProduct;
